import React from 'react';
import styles from './CSSZSickLeaveCertificateYearHeader.module.scss';

interface Props {
	year: number;
	count: number;
	isOpen: boolean;
	onToggle: (year: number) => void;
}

const CSSZSickLeaveCertificateYearHeader: React.FC<Props> = ({
	year,
	count,
	isOpen,
	onToggle,
}) => {
	return (
		<div className={styles.wrapper} onClick={() => onToggle(year)}>
			<div className={styles.title}>
				<span className={styles.chevron}>{isOpen ? '▾' : '▸'}</span>
				<span>{year}</span>
			</div>
			<div className={styles.count}>{count}</div>
		</div>
	);
};

export default CSSZSickLeaveCertificateYearHeader;
